"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var _excluded = ["alt", "className"];

var styles = function styles(theme) {
  return {
    root: {
      position: 'relative',
      minHeight: 50
    },
    galleryImage: {
      maxWidth: '100%',
      maxHeight: '100%',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    }
  };
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles);
/** Wrapper for individual item in a gallery, such as an image tag */

var GalleryImage = function GalleryImage(_ref) {
  var alt = _ref.alt,
      className = _ref.className,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.root, className)
  }, /*#__PURE__*/_react["default"].createElement("img", (0, _extends2["default"])({}, props, {
    className: classes.galleryImage,
    alt: alt
  })));
};

GalleryImage.propTypes = {
  /** Image source */
  src: _propTypes["default"].string.isRequired,

  /** Alternate text */
  alt: _propTypes["default"].node.isRequired
};
var _default = GalleryImage;
exports["default"] = _default;